import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FAQItem, generateFAQSchema } from '@/utils/schemaMarkup';

interface FAQSchemaProps {
  faqs: FAQItem[];
}

/**
 * Emits FAQPage JSON-LD for pages with visible Q&A content.
 */
export const FAQSchema: React.FC<FAQSchemaProps> = ({ faqs }) => {
  if (!faqs || faqs.length === 0) return null;
  const schema = generateFAQSchema(faqs);
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
